import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Table } from 'semantic-ui-react';

import { ReactComponent as PlusIcon } from '../../assets/images/plus-icon.svg';
import ActionsPopup from './ActionsPopup';

import styles from './SettingDashboard.module.scss';

const SettingDashboard = React.memo(({ data, canView, canEdit, onAdd, onDelete }) => {
  const [t] = useTranslation();

  return (
    <>
      {canView && (
        <div className={styles.wrapper}>
          <h2 className="page-title">{t('common.dashboard')}</h2>
          <div className={`text-right ${styles.button_add_wrapper}`}>
            {canEdit && (
              <button type="button" className={classNames(styles.brand_button_add)} onClick={onAdd}>
                <PlusIcon className={styles.addGridIcon} />
                {t('action.createComponent')}
              </button>
            )}
          </div>
          <Table singleLine className={styles.table_component}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell className="uppercase text-xs text-grey">
                  {t('common.dashboards.title')}
                </Table.HeaderCell>
                <Table.HeaderCell className="uppercase text-xs text-grey">
                  {t('common.dashboards.position')}
                </Table.HeaderCell>
                <Table.HeaderCell className="uppercase text-xs text-grey">
                  {t('common.dashboards.type')}
                </Table.HeaderCell>
                <Table.HeaderCell className="uppercase text-xs text-grey">
                  {t('common.dashboards.dataType')}
                </Table.HeaderCell>
                {canEdit && (
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {t('common.items.action')}
                  </Table.HeaderCell>
                )}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {data.map((component) => {
                return (
                  <Table.Row key={component.id}>
                    <Table.Cell>
                      <span className={styles.brand_name}>{component.title}</span>
                    </Table.Cell>
                    <Table.Cell>
                      <span className={styles.protocol}>{component.position}</span>
                    </Table.Cell>
                    <Table.Cell>
                      <span className={styles.factory_update}>
                        {component.component.replace('type', '')}
                      </span>
                    </Table.Cell>
                    <Table.Cell>
                      <span className={styles.factory_update}>
                        {t(`common.components.${component.dataType}`)}
                      </span>
                    </Table.Cell>
                    {canEdit && (
                      <Table.Cell>
                        <ActionsPopup componentId={component.id} onDelete={onDelete} />
                      </Table.Cell>
                    )}
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        </div>
      )}
    </>
  );
});

SettingDashboard.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  canView: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default SettingDashboard;
